// Page dimensions in pixels (at 96 DPI)
export const PAGE_DIMS = {
  letter:  { w: 816,  h: 1056, label: 'Letter (8.5×11")' },
  a4:      { w: 794,  h: 1123, label: 'A4 (210×297mm)' },
  legal:   { w: 816,  h: 1344, label: 'Legal (8.5×14")' },
  tabloid: { w: 1056, h: 1632, label: 'Tabloid (11×17")' },
  a3:      { w: 1123, h: 1587, label: 'A3 (297×420mm)' },
};

export const SNAP_SIZES = [0, 8, 16, 24];

// Page-number rendering formats for the default footer (when the user
// hasn't added their own footer visuals). Keys map to render strategies
// in canvas/PageRenderer.jsx; mirroring the keys here keeps the config
// vocabulary central.
export const PAGE_NUMBER_FORMATS = {
  none:    { label: 'None',           render: () => null },
  simple:  { label: '1',              render: (i, n) => `${i + 1}` },
  of_n:    { label: '1 of N',         render: (i, n) => `${i + 1} of ${n}` },
  verbose: { label: 'Page 1 of N',    render: (i, n) => `Page ${i + 1} of ${n}` },
};
